import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import * as locationApi from "../../../api/location";
import * as playtimeApi from "../../../api/playtime";

const HOST = import.meta.env.VITE_API_HOST;

export function useLocations() {
  return useQuery({
    queryKey: ["locations"],
    queryFn: () => locationApi.fetchAll(),
  });
}

/* ───────── Zones (read-only — managed via location modal) ───────── */

export function useZones() {
  return useQuery({
    queryKey: ["zones"],
    queryFn: () => playtimeApi.fetchZones(),
  });
}

export function useSaveLocation() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (req) => locationApi.saveOrUpdate(null, req),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["locations"] });
      qc.invalidateQueries({ queryKey: ["zones"] });
    },
  });
}

export function useArchiveLocation() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id) => locationApi.archive(null, id),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["locations"] });
    },
  });
}

export function useBookingServices(locationId) {
  return useQuery({
    queryKey: ["bookingServices", locationId],
    queryFn: async () => {
      if (!locationId) return [];
      const resp = await fetch(
        `${HOST}/api/v1/locations/${locationId}/booking-services`,
      );
      if (!resp.ok) return [];
      return resp.json();
    },
    enabled: !!locationId,
  });
}
